'use strict'

Vue.component('awe-ratings', {
  props: {
    reviewCount: {type: Number, default: 0},
    average: {type: Number, default: 0},
    roundedAverage: {type: Number, default: 0},
    maxRating: {type: Number, default: 5},
    icon: {type: String, default: '\u2605'}
  },
  data: function(){
    return {

    }
  },
  computed:{
    avgValue: function(){
      if (this.roundedAverage != null)
        return this.roundedAverage
      else if (this.average != null)
        return parseFloat(this.average.toFixed(1), 10)
      else
        return -1
    },
  },
  methods: {
    getClass: function(idx){
      const splitIdx = Math.trunc(this.avgValue)
      if (idx < splitIdx)
        return 'fill'
      else if (idx === splitIdx)
        return 'partial'
      return ''
    },
    getStyle: function(idx){
      if (idx !== Math.trunc(this.avgValue))
        return {}
      else {
        const fraction = this.avgValue - Math.trunc(this.avgValue)
        return {
          '--fill-ratio': `${fraction * 100}%`
        }
      }
    }
  },
  template: `
  <div class="ratings" v-show="avgValue !== -1">
    <div class="stars">
      <span v-for="(n, i) in maxRating" class="star"
        v-bind:class="getClass(i)"
        :style="getStyle(i)"
      >{{ icon }}</span>
    </div>
    <span class="count">({{reviewCount}})</span>
  </div>`
})
